// extracted by mini-css-extract-plugin
export default {"body":"App_body__CMMqV"};